import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'user_invitation-subuser_onboarding_page_account_created-action_unknown';

/**
 * Event to track successful sub user account created
 */
export function trackUserInvitationSubuserOnboardingPageAccountCreated(
  customParameterToken: string,
  customParameterToken2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken, customParameterToken2 },
  });
}
